import RouteName from '@/models/enums/RouteName'

export default [
  {
    path: '/slider',
    name: RouteName.Slider,
    component: () => import('@/pages/Slider/Slider'),
    meta: {
      breadcrumb: {
        label: 'Главный слайдер',
        parent: RouteName.Directory,
      },
    },
  },
  {
    path: '/slider/create',
    name: 'Создать слайд',
    component: () => import('@/pages/Slider/SliderCreate'),
    meta: {
      breadcrumb: {
        label: 'Новый слайд',
        parent: RouteName.Slider,
      },
    },
  },
  {
    path: '/slider/:id',
    name: 'Слайд',
    component: () => import('@/pages/Slider/SliderSingle'),
    meta: {
      breadcrumb: {
        label: 'Редактирование слайда',
        parent: RouteName.Slider,
      },
    },
  },
]
